(function () {
  if (window.GridBlogPagePaginationInitialized) return;
  window.GridBlogPagePaginationInitialized = true;

  async function loadGridPage(link) {
    const section = link.closest('.grid-blog-page');

    if (!section) return;

    const sectionId = section.dataset.sectionId;

    if (!sectionId || section.classList.contains('is-loading')) {
      return;
    }

    const linkUrl = new URL(link.href, window.location.origin);
    const requestUrl = new URL(linkUrl.toString());

    requestUrl.searchParams.set('section_id', sectionId);

    section.classList.add('is-loading');

    const oldGrid = section.querySelector('.grid-blog-page__grid');
    const oldPagination = section.querySelector(
      '.grid-blog-page__pagination'
    );

    if (oldGrid) {
      oldGrid.style.transition =
        'opacity 0.22s ease, transform 0.22s ease';

      oldGrid.style.opacity = '0';
      oldGrid.style.transform = 'translateY(8px)';
    }

    if (oldPagination) {
      oldPagination.style.transition = 'opacity 0.18s ease';
      oldPagination.style.opacity = '0';
    }

    try {
      const response = await fetch(requestUrl.toString(), {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to load section');
      }

      const html = await response.text();

      if (!html.trim()) {
        throw new Error('Empty section response');
      }

      const parser = new DOMParser();
      const documentHTML = parser.parseFromString(
        html,
        'text/html'
      );

      const newSection = documentHTML.querySelector(
        '#grid-blog-page-' + sectionId
      );

      if (!newSection) {
        throw new Error(
          'Grid Blog Page section not found'
        );
      }

      const newGrid = newSection.querySelector(
        '.grid-blog-page__grid'
      );

      const newPagination = newSection.querySelector(
        '.grid-blog-page__pagination'
      );

      if (!newGrid) {
        throw new Error('Grid not found');
      }

      await new Promise(function (resolve) {
        setTimeout(resolve, 180);
      });

      if (oldGrid) {
        oldGrid.replaceWith(newGrid);
      }

      if (oldPagination && newPagination) {
        oldPagination.replaceWith(newPagination);
      } else if (!oldPagination && newPagination) {
        const wrapper = section.querySelector(
          '.grid-blog-page__content-wrapper'
        );

        if (wrapper) {
          wrapper.appendChild(newPagination);
        }
      } else if (oldPagination && !newPagination) {
        oldPagination.remove();
      }

      window.history.pushState(
        {
          gridBlogPage: true,
          url: linkUrl.toString()
        },
        '',
        linkUrl.toString()
      );

      const sectionTop =
        section.getBoundingClientRect().top +
        window.scrollY -
        24;

      window.scrollTo({
        top: sectionTop,
        behavior: 'smooth'
      });

      animateGrid(section);
      animatePagination(section);

    } catch (error) {
      console.error(
        'Grid Blog Page AJAX error:',
        error
      );

      window.location.href = linkUrl.toString();

    } finally {
      setTimeout(function () {
        section.classList.remove('is-loading');
      }, 350);
    }
  }

  function animateGrid(section) {
    const grid = section.querySelector(
      '.grid-blog-page__grid'
    );

    if (!grid) return;

    grid.style.opacity = '0';
    grid.style.transform = 'translateY(8px)';
    grid.style.transition =
      'opacity 0.35s ease, transform 0.35s ease';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        grid.style.opacity = '1';
        grid.style.transform = 'translateY(0)';
      });
    });
  }

  function animatePagination(section) {
    const pagination = section.querySelector(
      '.grid-blog-page__pagination'
    );

    if (!pagination) return;

    pagination.style.opacity = '0';
    pagination.style.transition =
      'opacity 0.3s ease';

    setTimeout(function () {
      pagination.style.opacity = '1';
    }, 80);
  }

  async function loadHistoryPage() {
    const currentUrl = new URL(
      window.location.href
    );

    const section = document.querySelector(
      '.grid-blog-page[data-section-id]'
    );

    if (!section) return;

    const sectionId = section.dataset.sectionId;

    if (
      !sectionId ||
      section.classList.contains('is-loading')
    ) {
      return;
    }

    const requestUrl = new URL(
      currentUrl.toString()
    );

    requestUrl.searchParams.set(
      'section_id',
      sectionId
    );

    section.classList.add('is-loading');

    const oldGrid = section.querySelector(
      '.grid-blog-page__grid'
    );

    if (oldGrid) {
      oldGrid.style.transition =
        'opacity 0.2s ease, transform 0.2s ease';

      oldGrid.style.opacity = '0';
      oldGrid.style.transform =
        'translateY(8px)';
    }

    try {
      const response = await fetch(
        requestUrl.toString(),
        {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'text/html'
          }
        }
      );

      if (!response.ok) {
        throw new Error(
          'Failed to load page'
        );
      }

      const html = await response.text();

      if (!html.trim()) {
        throw new Error(
          'Empty section response'
        );
      }

      const parser = new DOMParser();

      const documentHTML =
        parser.parseFromString(
          html,
          'text/html'
        );

      const newSection =
        documentHTML.querySelector(
          '#grid-blog-page-' + sectionId
        );

      if (!newSection) {
        throw new Error(
          'Section not found'
        );
      }

      const newGrid =
        newSection.querySelector(
          '.grid-blog-page__grid'
        );

      const newPagination =
        newSection.querySelector(
          '.grid-blog-page__pagination'
        );

      if (!newGrid) {
        throw new Error(
          'Grid not found'
        );
      }

      await new Promise(function (resolve) {
        setTimeout(resolve, 180);
      });

      if (oldGrid) {
        oldGrid.replaceWith(newGrid);
      }

      const oldPagination =
        section.querySelector(
          '.grid-blog-page__pagination'
        );

      if (
        oldPagination &&
        newPagination
      ) {
        oldPagination.replaceWith(
          newPagination
        );
      } else if (
        oldPagination &&
        !newPagination
      ) {
        oldPagination.remove();
      } else if (
        !oldPagination &&
        newPagination
      ) {
        const wrapper =
          section.querySelector(
            '.grid-blog-page__content-wrapper'
          );

        if (wrapper) {
          wrapper.appendChild(
            newPagination
          );
        }
      }

      animateGrid(section);
      animatePagination(section);

    } catch (error) {
      console.error(
        'Grid Blog Page history error:',
        error
      );

    } finally {
      setTimeout(function () {
        section.classList.remove(
          'is-loading'
        );
      }, 350);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const link =
        event.target.closest(
          '[data-grid-pagination]'
        );

      if (!link) return;

      if (
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey ||
        link.target === '_blank'
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      loadGridPage(link);
    },
    true
  );

  window.addEventListener(
    'popstate',
    function () {
      loadHistoryPage();
    }
  );
})();